import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";

import client from "../apis/client";
import LabelsCard from "../infrastructure/components/LabelsCard";
import CourseFilterForm from "../infrastructure/components/CourseFilterForm";
import { useFormik } from "formik";

const VideotekaPage = (props) => {
  const [videos, setVideos] = useState([]);
  const [, setIsLoading] = useState(false);

  const initialValues = {
    label: "",
  };

  const applyFilter = async (values) => {
    try {
      setIsLoading(true);
      let str = "";
      if (values.label !== "" && values.label !== "id")
        str += `labels=${values.label}&`;

      let fil = await client.get(`/education/courses/?${str.slice(0, -1)}`);

      if (fil.status === 200) {
        setVideos(fil.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleResetForm = async () => {
    try {
      const vid = await client.get(`/education/courses/`);

      if (vid.status === 200) {
        setVideos(vid.data);
      }
    } catch (err) {
      console.log(err.response);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: applyFilter,
    onReset: handleResetForm,
  });

  useEffect(() => {
    let isActive = true;
    const loadData = async () => {
      try {
        const vid = await client.get(`/education/courses/`);

        if (isActive) {
          if (vid.status === 200) {
            setVideos(vid.data);
          }
        }
      } catch (err) {
        console.log(err.response);
      }
    };

    if (isActive) loadData();

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <Container component="main" maxWidth="xl">
      <CourseFilterForm formik={formik} />
      <div style={{ height: "3rem" }} />
      {videos && <LabelsCard labels={videos} />}
    </Container>
  );
};

export default VideotekaPage;
